import { CSSProperties } from "react";

export type TransformApiProps = {
  translateX?: number;
  translateY?: number;
  translateZ?: number;
  rotateX?: number;
  rotateY?: number;
  rotateZ?: number;
  opacity?: CSSProperties["opacity"];
};

export const transformApi = (props: TransformApiProps) => {
  const { translateX, translateY, translateZ, rotateX, rotateY, rotateZ } = props;

  const functions: string[] = [];
  if (translateZ !== undefined) {
    functions.push(`translate3d(${translateX ?? 0}px, ${translateY ?? 0}px, ${translateZ}px)`);
  } else if (translateX !== undefined || translateY !== undefined) {
    functions.push(`translate(${translateX ?? 0}px, ${translateY ?? 0}px)`);
  }
  if (rotateX !== undefined) functions.push(`rotateX(${rotateX}deg)`);
  if (rotateY !== undefined) functions.push(`rotateY(${rotateY}deg)`);
  if (rotateZ !== undefined) functions.push(`rotateZ(${rotateZ}deg)`);

  return {
    // A transform (even identity) creates a stacking context and a containing
    // block for fixed/absolute descendants, so only emit it when requested.
    ...(functions.length > 0 && {
      transform: functions.join(" "),
      transformOrigin: "50% 50%",
    }),
    opacity: props.opacity,
  };
};
